import RNG from "../components/rng";
import React, { useState } from "react";
function Home() {
  const [RedColor, setR] = useState("0");
  const [GreenColor, setG] = useState("0");
  const [BlueColor, setB] = useState("0");
  const [hasbackground, newBackground] = useState("rgb(0, 0, 0)");

  let RGB = "";
  function getRGB() {
    setR(RNG());
    setG(RNG());
    setB(RNG());
    RGB = "rgb(" + RedColor + ", " + GreenColor + ", " + BlueColor + ")";
    newBackground(RGB);
  }

  return (
    <div className="home" style={{ background: hasbackground }}>
      <div className="top-bar">
        <div className="red-val"></div>
        <div className="green-val">{hasbackground}</div>
        <div className="blue-val"></div>
      </div>

      <button className="pushable">
        <span className="front" onClick={() => getRGB()}>
          New Color
        </span>
      </button>
    </div>
  );
}

export default Home;
